import { UUID } from '@/types';
import { useSelector } from 'react-redux';
import { getDashboardState } from '@/features/dashboardShare/store-selectors';
import { rootDomain } from '@/util/helpers/essential-helpers';
import { useDashboardId, useDatasourceId } from '@/hooks';

export const getUrlPrivate = (datasourceId: UUID, dashboardId: UUID) => {
  return `${rootDomain()}/datasources/${datasourceId}/dashboards/${dashboardId}/open`;
};

export const getUrlPublic = (
  dashboardPublicId: Nullable<string>,
  publicPin: Nullable<string>,
) => {
  const url = `${rootDomain()}/share/dashboard/${dashboardPublicId}/load.html`;
  return `${url}?pin=${publicPin}`;
};

export const useDashboard = () => {
  const datasourceId = useDatasourceId();
  const dashboardId = useDashboardId();

  const { publicPin, publicId, isPublic } = useSelector(getDashboardState);

  const shareDashboardPrivateUrl = getUrlPrivate(datasourceId, dashboardId);
  const shareDashboardPublicUrl = isPublic
    ? getUrlPublic(publicId, publicPin)
    : null;

  return {
    shareDashboardPrivateUrl,
    shareDashboardPublicUrl,
  };
};
